import request from "../utils/request";
export function getAiStyleList(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/comfyUiWorkflow/list?${queryString}`,
        method: "get"
    });
}
export function getAiStyleById(params) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/comfyUiWorkflow/queryById?${queryString}`,
        method: "get"
    });
}


export function updateAiStyleById(params) {
    return request({
        url: `/comfyUiWorkflow/update`,
        method: "post",
        data: params
    });
}


export function createAiStyle(params) {
    return request({
        url: `/comfyUiWorkflow/add`,
        method: "post",
        data: params
    });
}


export function deleteAiStyle(params) {
    return request({
        url: `/comfyUiWorkflow/delete`,
        method: "post",
        data: params
    });
}